import * as React from 'react';

import { Modal } from '../../../../../Modal';
import { HeaderLogoAndTel } from '../../../../../HeaderLogoAndTel';
import { HeaderWithPartner } from "../../HeaderWithPartner";
import { TaxDeduction } from "../../../../../TaxDeduction";

import * as main from '../../../styles/mainOld.module.scss';
import * as hero from './hero.module.scss';

export const HeroModules = ({ buttonText, widget, partner=false, isModal=true, free=false }) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <section>
      <div className={'container'}>
        {
          !partner ?
            <HeaderLogoAndTel />
            :
            <HeaderWithPartner/>
        }

        <div className={hero.hero__content}>
          <div className={hero.hero__text}>
            <h1 className={hero.hero__title}>Как воспитать гармонично развитого ребёнка?</h1>
            <p className={hero.hero__description}>
              «Учись Учиться» — онлайн-курс для <b>эффективного развития мышления ребёнка</b>, который научит ребенка
              учиться самостоятельно и с удовольствием
            </p>
            <ul className={hero.hero__list}>
              <li className={hero.hero__item}>
                <p>Повышает эффективность обучения и мотивацию учиться. </p>
              </li>
              <li className={hero.hero__item}>
                <p>Помогает развить навыки и качества, важные для успеха в будущем. </p>
              </li>
              <li className={hero.hero__item}>
                <p>Для учащихся 8—11 классов.</p>
              </li>
            </ul>

            {isModal ? (
              <>
                <button
                  className={main.btn}
                  onClick={() => {
                    setShowModal(true);
                  }}
                >
                  {buttonText}
                </button>
                { !free && <TaxDeduction margin={"30px 0 0"}/> }
              </>
            ) : (
              <a className={main.btn} href={'#user-action'}>
                {buttonText}
              </a>
            )}

          </div>
          <div className={hero.hero__img}></div>
        </div>
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </section>
  );
};
